export default __webpack_public_path__ + "static/propmeabout-988b44246ea1b59092604dd07800ea0e.png";